import { rgb, StandardFonts } from "pdf-lib";
import bwipjs from "bwip-js";
import axios from "@/includes/connection";

export async function participantName(
  page,
  pdfDoc,
  name,
  yPosition,
  fontSize = 16
) {
  try {
    const font = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);
    const { width } = page.getSize();
    const textWidth = font.widthOfTextAtSize(name, fontSize);
    const xPosition = (width - textWidth) / 2;

    page.drawText(name, {
      x: xPosition,
      y: yPosition,
      size: fontSize,
      font: font,
      color: rgb(0, 0, 0),
    });

    return true;
  } catch (error) {
    console.error("Error nombre", error);
    return false;
  }
}

export async function dateNow(
  page,
  pdfDoc,
  text,
  yPosition,
  margin,
  fontSize = 16
) {
  try {
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const { width } = page.getSize();
    const textWidth = font.widthOfTextAtSize(text, fontSize);
    const xPosition = width - margin - textWidth;

    page.drawText(text, {
      x: xPosition,
      y: yPosition,
      size: fontSize,
      font: font,
    });

    return true;
  } catch (error) {
    console.error("Error now", error);
    return false;
  }
}

export async function participantQRCode(text) {
  try {
    const canvas = document.createElement("canvas");

    bwipjs.toCanvas(canvas, {
      bcid: "qrcode",
      text: text,
      scale: 3,
      includetext: false,
    });

    const pngUrl = canvas.toDataURL("image/png");
    const pngBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());

    return pngBytes;
  } catch (error) {
    console.error("Error QRCode", error);
    throw new Error("Error QR");
  }
}

export async function drawCenteredText(
  page,
  pdfDoc,
  text,
  y,
  size,
  color = rgb(0.1, 0.1, 0.1)
) {
  try {
    const font = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);
    const { width } = page.getSize();
    const textWidth = font.widthOfTextAtSize(text, size);
    const x = (width - textWidth) / 2;

    page.drawText(text, {
      x,
      y,
      size,
      font,
      color,
    });
  } catch (error) {
    console.error("Error Texxt center", error);
    throw new Error("Error TextCenter");
  }
}

export async function getTemplate() {
  try {
    let pdf = await fetch("/B40J5Xr6ECLC9eSQ65ULh9PeBlDyLW.pdf").then((res) => {
      if (!res.ok) {
        throw new Error(`Error ${res.status}`);
      }
      return res.arrayBuffer();
    });
    return pdf;
  } catch (error) {
    console.error("Error ", error);
    throw new Error("Error", error);
  }
}

export async function setDownload(id) {
  try {
    await axios
      .post(`/certification/setdownload/${id}`)
      .then((response) => {
        if (response.ok) {
          //console.log("download", download);
          return true;
        }
      })
      .catch((error) => {
        console.error("Error download", error);
        return false;
      });
  } catch (error) {
    console.error("Error", error);
  }
}

export async function drawWrappedText(
  page,
  pdfDoc,
  text,
  xMargin = 80,
  yStart = 250,
  fontSize = 16,
  lineHeight = 20,
  rightMargin = 80
) {
  const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const { width } = page.getSize();
  const maxWidth = width - xMargin - rightMargin;

  const words = text.split(" ");
  let line = "";
  let y = yStart;

  for (let i = 0; i < words.length; i++) {
    const testLine = line ? line + " " + words[i] : words[i];
    const textWidth = font.widthOfTextAtSize(testLine, fontSize);

    if (textWidth > maxWidth && line !== "") {
      page.drawText(line, {
        x: xMargin,
        y,
        size: fontSize,
        font,
      });

      line = words[i];
      y -= lineHeight;
    } else {
      line = testLine;
    }
  }

  if (line) {
    page.drawText(line, {
      x: xMargin,
      y,
      size: fontSize,
      font,
    });
  }
}
